import React from 'react';
import Downshift from 'downshift';
import request from 'superagent';
import { get as getCookie } from 'cookies-js';

// The accounts search XHR endpoint returns highlighted results containing <em> tags with content that's already html escaped
const safe = html => <span dangerouslySetInnerHTML={{ __html: html }} />;

/**
 * A search input with autocomplete + search results list
 */
export default class UserSearchPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            results: [],
        };

        this.search = this.search.bind(this);
        this.becomeUser = this.becomeUser.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
        this.request = null;
    }

    search(query) {
        if (this.request) {
            this.request.abort();
        }

        if (query.trim() === '') {
            return;
        }

        this.request = request
            .get('/accounts/xhr/search')
            .query({ q: query })
            .accept('json')
            .timeout(10000)
            .end(this.handleResponse);
    }

    handleResponse(err, response) {
        if (err) throw err;

        this.setState({
            results: response.body.map(({ source, highlight }) => ({
                id: source.userid,
                userId: highlight.userid ? safe(highlight.userid) : null,
                displayName: highlight.displayname
                    ? safe(highlight.displayname)
                    : source.displayname,
                fullName: highlight.fullname ? safe(highlight.fullname) : null,
                email: highlight.email ? safe(highlight.email) : source.email,
            })),
        });
    }

    becomeUser(userId) {
        request
            .post('/admin/becomeuser')
            .type('form')
            .send({
                submission_token: getCookie('_99csrf'),
                userid: userId,
            })
            .end((e, r) => {
                window.location.reload();
            });
    }

    render() {
        return (
            <Downshift
                onChange={id => {
                    window.location.href = `/users/${id}`;
                }}
                onInputValueChange={value => this.search(value)}
            >
                {({ getInputProps, getItemProps, inputValue, highlightedIndex, selectedItem }) => (
                    <div>
                        <input
                            {...getInputProps({
                                autoFocus: true,
                                type: 'text',
                                className: 'input-text input-text--admin-bar-search-input',
                                placeholder: 'User search',
                            })}
                        />

                        {this.state.results.length > 0 && (
                            <div className="admin-user-search-results">
                                {this.state.results.map((user, i) => (
                                    <div
                                        {...getItemProps({
                                            item: user.id,
                                            index: i,
                                            key: user.id,
                                            className:
                                                'admin-user-search-result' +
                                                (highlightedIndex === i
                                                    ? ' admin-user-search-result--highlighted'
                                                    : '') +
                                                (selectedItem === i
                                                    ? ' admin-user-search-result--selected'
                                                    : ''),
                                        })}
                                    >
                                        <a
                                            href={`/users/${user.id}`}
                                            className="admin-user-search-result__link"
                                        >
                                            <span className="admin-user-search-result__avatar">
                                                <img
                                                    className="admin-user-search-result__avatar__img"
                                                    src={`/avatars/users/${user.id}/25`}
                                                    height="25"
                                                    width="25"
                                                />
                                            </span>
                                            <div className="admin-user-search-result__display-name">
                                                {user.displayName}
                                            </div>
                                            {user.fullName && (
                                                <div className="admin-user-search-result__full-name">
                                                    Fullname: {user.fullName}
                                                </div>
                                            )}
                                            {user.userId && (
                                                <div className="admin-user-search-result__userid">
                                                    Userid: {user.userId}
                                                </div>
                                            )}
                                            <div className="admin-user-search-result__email">
                                                {user.email}
                                            </div>
                                        </a>
                                        <div className="admin-user-search-result__actions">
                                            <button
                                                className="admin-user-search-result__actions__item"
                                                title="Become this user"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    this.becomeUser(user.id);
                                                }}
                                            >
                                                <span className="icon icon--repeat-1" />
                                            </button>
                                            <a
                                                href={`/admin/users/${user.id}`}
                                                className="admin-user-search-result__actions__item"
                                                title="User admin page"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    window.location.href = `/admin/users/${
                                                        user.id
                                                    }`;
                                                }}
                                            >
                                                <span className="icon icon--admin-1" />
                                            </a>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}
            </Downshift>
        );
    }
}



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/AdminBar/UserSearchPanel.jsx